import type * as React from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

import {
  NotificationsMenu,
  type AppNotification,
  type AppNotificationGroup,
  type NotificationsLabels
} from "@/zapi-frontend/features/Notifications";
import {
  OrganizationMenu,
  type Organization,
  type OrganizationMember,
  type OrganizationMenuAction,
  type OrganizationMenuLabels
} from "./OrganizationMenu";

function AccountBar({
  organization,
  member,
  notifications,
  notificationsLoading,
  notificationsError,
  notificationsLabels,
  onRetryNotifications,
  onMarkAllNotificationsRead,
  onMarkNotificationGroupRead,
  onNotificationSelect,
  showsOrganizationActions,
  organizationMenuLabels,
  organizationMenuItems,
  onOrganizationAction,
  className
}: {
  organization: Organization;
  member?: OrganizationMember;
  notifications: AppNotification[];
  notificationsLoading?: boolean;
  notificationsError?: boolean;
  notificationsLabels: NotificationsLabels;
  onRetryNotifications?: () => void;
  onMarkAllNotificationsRead?: () => void;
  onMarkNotificationGroupRead?: (group: AppNotificationGroup) => void;
  onNotificationSelect?: (notification: AppNotification) => void;
  showsOrganizationActions: boolean;
  organizationMenuLabels: OrganizationMenuLabels;
  organizationMenuItems?: React.ReactNode;
  onOrganizationAction?: (action: OrganizationMenuAction) => void;
  className?: string;
}) {
  return (
    <div data-slot="account-bar" className={cn("flex min-w-0 items-center gap-1 sm:gap-2", className)}>
      <NotificationsMenu
        notifications={notifications}
        labels={notificationsLabels}
        loading={notificationsLoading}
        error={notificationsError}
        onRetry={onRetryNotifications}
        onMarkAllRead={onMarkAllNotificationsRead}
        onMarkGroupRead={onMarkNotificationGroupRead}
        onSelect={onNotificationSelect}
      />
      <OrganizationMenu
        organization={organization}
        member={member}
        showsOrganizationActions={showsOrganizationActions}
        labels={organizationMenuLabels}
        onAction={onOrganizationAction}
      >
        {organizationMenuItems}
      </OrganizationMenu>
    </div>
  );
}

export { AccountBar };
